import ZeissButton from '@components/button';
import ZeissModal from '@components/zeiss-modal';
import { Space } from 'antd';
import './index.scss';
export const SubjectMatterCheckPopup = ({
  open,
  handleCancel,
  handleOk
}: any) => {
  return (
    <ZeissModal
      open={open}
      width={520}
      centered
      footer={null}
      onCancel={handleCancel}
    >
      <div className="pc-forwardAnn-layout">
        <div className="pc-forwardAnn-title" style={{ marginBottom: '0' }}>
          已处理完当前公告下的全部标的物
        </div>
        <div className="pc-subLayout" style={{ padding: 0 }}>
          <Space className="pc-matter-createAnn-footer" size="middle">
            <ZeissButton
              type="primary"
              className="pc-confirm-btn"
              onClick={handleOk}
            >
              确认公告处理完成
            </ZeissButton>
          </Space>
        </div>
      </div>
    </ZeissModal>
  );
};
